// extracted by mini-css-extract-plugin
module.exports = {"container":"UserActionsCell_container__2uU6C"};